import React, { useId } from 'react'
import PropTypes from 'prop-types'

const PlusSquareIcon = React.forwardRef(function PlusSquareIcon(props, ref) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 7C12.5523 7 13 7.44772 13 8V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V8C11 7.44772 11.4477 7 12 7Z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 12C7 11.4477 7.44772 11 8 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8C7.44772 13 7 12.5523 7 12Z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 2C3.80228 2 2 3.80228 2 6V18C2 20.1977 3.80228 22 6 22H18C20.1977 22 22 20.1977 22 18V6C22 3.80228 20.1977 2 18 2H6ZM0 6C0 2.69772 2.69772 0 6 0H18C21.3023 0 24 2.69772 24 6V18C24 21.3023 21.3023 24 18 24H6C2.69772 24 0 21.3023 0 18V6Z"
        ></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

PlusSquareIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

PlusSquareIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default PlusSquareIcon
